import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@toman/ui-kit-light";
import { notFoundSvg } from "../assets/images";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-background-surface gap-4">
      <img draggable={false} src={notFoundSvg} alt="404" className="w-[180px] h-[180px]" />
      <span className="text-md-semi-bold text-text-primary">صفحه مورد نظر پیدا نشد</span>
      <Button variant="filled" onClick={() => navigate("/")}>
        بازگشت به صفحه اصلی
      </Button>
    </div>
  );
};

export default NotFoundPage;
